import api from 'api'

type PreviewDocumentSignatureTemplateRequest = {
  data: Record<string, string | boolean>
}

export async function previewDocumentSignatureTemplate(
  companyId: number,
  fileId: number,
  body: PreviewDocumentSignatureTemplateRequest
) {
  const response = await api.post<Blob>(
    `/admin/company/${companyId}/files/${fileId}/preview`,
    body,
    {
      responseType: 'blob',
    }
  )
  return response.data
}
